<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * * * The content below * * * * * * * * * * * -->
<!-- * * * * * * * * * * is only a placeholder * * * * * * * * * * -->
<!-- * * * * * * * * * * and can be replaced.  * * * * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->
<!-- * * * * * * * * * Delete the template below * * * * * * * * * -->
<!-- * * * * * * * to get started with your project! * * * * * * * -->
<!-- * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * -->

<style>
  







</style>
<!-- #1182 lot 1 — bandeau de péremption du bundle. Monté au-dessus de TOUT,
     backoffice compris : un onglet staff périmé pilote le site avec du code
     obsolète, ce qui est au moins aussi gênant qu'un onglet client. -->
<app-stale-bundle-banner></app-stale-bundle-banner>

<!-- #1182 lot 2 — l'écran de maintenance remplace l'application, en-tête et pied
     de page compris : ils appartiennent au site qu'on vient d'éteindre.
     `AppComponent` a déjà exclu le staff et les routes d'authentification et de
     pilotage — sans quoi on s'enfermerait dehors. -->
<app-maintenance-screen *ngIf="maintenanceActive"
                        [message]="maintenanceMessage"
                        [until]="maintenanceUntil"></app-maintenance-screen>

<ng-container *ngIf="!maintenanceActive">
  <app-header-figma-complete *ngIf="!isBackoffice"></app-header-figma-complete>
  <main [class.backoffice-main]="isBackoffice">
      <router-outlet />
  </main>
  <app-footer *ngIf="!isBackoffice"></app-footer>
</ng-container>

<!-- T11 — canonical NotificationService UI shell (always-mounted) -->
<app-notification-toast-container></app-notification-toast-container>
<app-notification-confirmation-dialog></app-notification-confirmation-dialog>
<app-notification-loading-overlay></app-notification-loading-overlay>


